export const typeQueryTrendingFilms = ['day', 'week']
export const typeQueryFilms = ['movie', 'tv']